import { assets } from "@core/assets";
import { useTranslate } from "@core/hooks";
import { FormattedDate } from "@core/components/date";

export type DateType =
  | "created"
  | "updated"
  | "assigned"
  | "joined"
  | "invited";
export type DisplayType = "table" | "details";

type DateIndicatorProps = {
  date: string | Date | undefined;
  displayType: DisplayType | undefined;
  dateType: DateType | undefined;
};

function DateIndicator({ date, displayType, dateType }: DateIndicatorProps) {
  const { t } = useTranslate();
  const TimeIcon = assets["clock"];
  const displayDateType = (dateType: DateType | undefined) => {
    switch (dateType) {
      case "created":
        return t("created-at");
      case "updated":
        return t("updated-at");
      case "joined":
        return t("joined-at");
      case "invited":
        return t("invited-in");
      case "assigned":
        return t("assigned-at");
    }
  };
  return (
    <div className="flex items-center gap-1 w-full">
      <TimeIcon className="text-neutral-400" />
      {displayType === "details" && (
        <h5 className="text-neutral-400">{displayDateType(dateType)}</h5>
      )}
      <FormattedDate date={date} displayType={displayType} />
    </div>
  );
}

export default DateIndicator;
